
import { Card, Col, Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { useLoginStore } from '../../stores/useLoginStore'

const ReporteCoordinacion = () => {

  const objLogueado = useLoginStore( store => store.objLogueado )

  return (
    <>
      <div className='lead' style={{ marginBottom: 10 }}>Seleccione una carrera para ver los reportes.</div>
      
      <Row gutter={16}>
        { objLogueado.carreras.map( (e, i) => (
          <Col xs={ 24 } md={ 12 } lg={ 8 } xl={ 8 } key={ i }>
            <Link to={ '/reporte-carrera/'+e.pk_carrera }>
              <Card
                hoverable
              >
                { e.carrera }
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
      
    </>
  )
}

export default ReporteCoordinacion
